<template>
<div class="app-wrapper">
  <top-bar></top-bar>
  <div class="main-container-home">
    <app-main></app-main>
  </div>
</div>
</template>

<script>
import { AppMain, TopBar } from './components'

export default {
  name: 'layout',
  components: {
    AppMain,
    TopBar
  }
}
</script>

<style lang='less' scoped>
 @import '~@/styles/variables.less';
.app-wrapper {
  .clearfix {
    &:after {
      content: "";
      display: table;
      clear: both;
    }
  }
  position: relative;
  height: 100%;
  width: 100%;
  .main-container-home {
    width: 100%;
    height: 1080 * @uh;
  }
}
</style>
